document.addEventListener("DOMContentLoaded", () => {
  $('.section-vitrine-produtos').each(function() {
    const $section = $(this); // vitrine atual
    $section.find('.slick-vitrine').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $section.find('.prev-arrow'),
      nextArrow: $section.find('.next-arrow'),
      dots: false,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 651,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  });
});